import React, { useEffect, useState } from "react";
// import LocationInput from "./LocationInput";
import ThingInput from "./ThingInputForm";
import { FocusedInputShape } from "react-dates";
// import RentalCarDatesRangeInput from "./RentalCarDatesRangeInput";
import ButtonSubmit from "./ButtonSubmit";
import { FC } from "react";
import moment from "moment";
import { useHistory } from "react-router";
import { IInput } from "types/interfaces";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { RootState } from "store";
import { useSelector } from "react-redux";

export interface DateRage {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

export interface TimeRage {
  startTime: string;
  endTime: string;
}

export interface RentalCarSearchFormProps {
  haveDefaultValue?: boolean;
  focus?: boolean;
}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = ({
  haveDefaultValue,
  focus,
}) => {
  const { userInfo } = useSelector((state: RootState) => state.userInfo);

  const history = useHistory();

  // eslint-disable-next-line
  const [dateRangeValue, setDateRangeValue] = useState<DateRage>({
    startDate: null,
    endDate: null,
  });
  // const [timeRangeValue, setTimeRangeValue] = useState<TimeRage>({
  //   startTime: "10:00 AM",
  //   endTime: "10:00 AM",
  // });

  // Dia buat safety netnya disini, jadi ada value ada warning jg
  const [thingValue, setThingValue] = useState<IInput>({
    value: "",
    warning: "",
  });
  const [pickUpInputValue, setPickUpInputValue] = useState("");
  const [dropOffInputValue, setDropOffInputValue] = useState("");
  // eslint-disable-next-line
  const [fieldFocused, setFieldFocused] = useState<
    FocusedInputShape | "pickUpInput" | "dropOffInput" | null
  >(null);
  const [dropOffLocationType, setDropOffLocationType] = useState<
    "same" | "different"
  >("same");

  // USER EFFECT
  useEffect(() => {
    if (haveDefaultValue) {
      setDateRangeValue({
        startDate: moment(),
        endDate: moment().add(4, "days"),
      });

      setPickUpInputValue(pickUpInputValue);
      setDropOffInputValue(dropOffInputValue);
    }
  }, []);

  // Handlingnya disini binn, jadi dia andaikata valuenya gaada, yang muncul warning, sedangkan kalau ada dia bakal ke path /listing?name=${nama}
  const handleSubmit = (e: any) => {
    if (thingValue.value) {
      logging(userInfo?.token, {
        category: "product",
        action: "search",
        target: thingValue.value || "",
      });

      eventAnalytic({
        category: "Product",
        action: "Search",
        label: thingValue.value,
      });
      history.push(`/listing?name=${thingValue.value}`);
    } else {
      setThingValue({ value: "", warning: "Masukkan nama barang" });
    }
    e.preventDefault();
  };

  // eslint-disable-next-line
  const renderRadioBtn = () => {
    return (
      <div className=" py-5 [ nc-hero-field-padding ] flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-10 border-b border-neutral-100 dark:border-neutral-800">
        <div className="flex  items-center">
          <input
            id="same-drop-off"
            name="drop-off-type"
            type="radio"
            value="same"
            className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
            checked={dropOffLocationType === "same"}
            onChange={(e) =>
              setDropOffLocationType(e.currentTarget.value as "same")
            }
          />
          <label
            htmlFor="same-drop-off"
            className="ml-2 sm:ml-3 block text-sm font-medium text-gray-700 dark:text-neutral-300"
          >
            Lokasi sewa dan pengembalian sama
          </label>
        </div>
        <div className="flex items-center">
          <input
            id="different-drop-off"
            name="drop-off-type"
            value="different"
            type="radio"
            className="focus:ring-primary-500 h-4 w-4 text-primary-500 border-neutral-300"
            checked={dropOffLocationType === "different"}
            onChange={(e) =>
              setDropOffLocationType(e.currentTarget.value as "different")
            }
          />
          <label
            htmlFor="different-drop-off"
            className="ml-2 sm:ml-3 block text-sm font-medium text-gray-700 dark:text-neutral-300"
          >
            Lokasi sewa dan pengembalian berbeda
          </label>
        </div>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className="w-full">
        <form
          className="w-full relative lg:mt-8 rounded-3xl shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-900"
          onSubmit={handleSubmit}
        >
          {/* {renderRadioBtn()} */}
          <div className=" flex flex-col md:flex-row md:items-center w-full rounded-full [ nc-divide-field ] ">
            <div className="relative flex flex-col md:flex-row nc-flex-2-auto [ nc-divide-field ] ">
              <ThingInput
                autoFocus={focus}
                defaultValue={thingValue.value}
                onChange={(e) => {
                  setThingValue({ value: e, warning: "" });
                }}
                onInputDone={() => setFieldFocused("pickUpInput")}
                placeHolder="Lagi Cari Gear Apa?"
                desc="Tenda... Hiking Pole... Carrier..."
              />

              {/* <div className="flex flex-col">
                <LocationInput
                  defaultValue={pickUpInputValue}
                  onChange={(e) => setPickUpInputValue(e)}
                  onInputDone={() =>
                    setFieldFocused(
                      dropOffLocationType === "different"
                        ? "dropOffInput"
                        : "startDate"
                    )
                  }
                  placeHolder="Lokasi pengambilan"
                  desc="Pilih lokasi yang sesuai"
                  autoFocus={fieldFocused === "pickUpInput"}
                />
                {dropOffLocationType === "different" && (
                  <LocationInput
                    defaultValue={dropOffInputValue}
                    onChange={(e) => setDropOffInputValue(e)}
                    onInputDone={() => setFieldFocused("startDate")}
                    placeHolder="Lokasi pengembalian"
                    desc="Pilih lokasi pengembalian"
                    autoFocus={fieldFocused === "dropOffInput"}
                  />
                )}
              </div> */}
            </div>
            {/* <RentalCarDatesRangeInput
              defaultDateValue={dateRangeValue}
              defaultTimeValue={timeRangeValue}
              defaultFocus={
                fieldFocused === "dropOffInput" ? null : fieldFocused
              }
              onFocusChange={(focus) => setFieldFocused(focus)}
              onChange={(data) => {
                setDateRangeValue(data.stateDate);
                setTimeRangeValue(data.stateTimeRage);
              }}
            /> */}
            {/* BUTTON SUBMIT OF FORM */}
            <div className="px-4 py-3">
              <ButtonSubmit />
            </div>
          </div>
          {/* Penggunaan method warning */}
          {thingValue.warning && (
            <span className="pl-20 text-red-600">{thingValue.warning}</span>
          )}
        </form>
      </div>
    );
  };

  return renderForm();
};

export default RentalCarSearchForm;
